import { AblyProvider } from 'ably/react';
import { getAblyClient } from 'personalization-lib/utils/ably/client';
import { jsx as _jsx } from "react/jsx-runtime";
const PersonalizationAblyProvider = ({
  children
}) => /*#__PURE__*/_jsx(AblyProvider, {
  client: getAblyClient(),
  children: children
});
export default PersonalizationAblyProvider;